import { render, staticRenderFns } from "./DocumentDetails.vue?vue&type=template&id=52f2da62&"
import script from "./DocumentDetails.vue?vue&type=script&lang=js&"
export * from "./DocumentDetails.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetails.vue?vue&type=style&index=0&id=52f2da62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports